import { Box, Skeleton } from '@mui/material';

export default function ConfigureSkeleton() {
  return (
    <Box>
      {/* Scrollable Content Skeleton */}
      <Box
        sx={{
          flex: 1,
          overflow: 'auto'
        }}
      >
        {/* Business List Skeleton */}
        <Box mt={2} sx={{ maxHeight: '100%', overflowY: 'auto' }}>
          {[...Array(8)].map((_, index) => (
            <Box key={index} mb={2}>
              <Box display='flex' alignItems='center' gap={2}>
                <Skeleton variant='rectangular' width={20} height={20} sx={{ borderRadius: 0.5 }} />
                <Box flex={1}>
                  <Skeleton variant='text' width={`${60 + Math.random() * 30}%`} height={20} />
                  <Skeleton variant='text' width={`${40 + Math.random() * 20}%`} height={16} sx={{ mt: 0.5 }} />
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
